import * as React from 'react';
import styled from 'styled-components';
import { themeGet, media, Icon } from '@packages/ui';

const ICON_SIZE = 16;

const Text = styled.span`
  font-size: ${themeGet.fontSize(6)};
`;

const IconWrapper = styled.div`
  margin-right: ${themeGet.space(2)};
`;

const Container = styled.div`
  display: flex;
  flex-direction: column-reverse;

  justify-content: center;
  margin: 0 ${themeGet.space(3)};

  section {
    display: flex;
    margin-right: ${themeGet.space(3)};
    line-height: ${themeGet.fontSize(6)};

    ${media.to.md`
      margin-bottom: ${themeGet.space(2)};
      justify-content: center;
  `}
  }

  ${media.from.md`
    flex-direction:row;
  `}
`;

export interface NewsletterFooterSubmitMessageProps {
  msgs: string[];
}

export const NewsletterHeadingForContentful: React.FC<NewsletterFooterSubmitMessageProps> = ({ msgs }) => {
  return (
    <Container>
      {msgs.map((msg, index) => (
        <section key={`newsletter-heading-${index}`}>
          <IconWrapper>
            <Icon name="newsletter" color="primary" size={ICON_SIZE} />
          </IconWrapper>
          <Text>{msg}</Text>
        </section>
      ))}
    </Container>
  );
};
